import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { HeroSection } from "@/components/landing/HeroSection";
import { FeaturesSection } from "@/components/landing/FeaturesSection";
import { HowItWorksSection } from "@/components/landing/HowItWorksSection";
import { PricingSection } from "@/components/landing/PricingSection";
import { LanguageSwitcher } from "@/components/ui/language-switcher";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Landing = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="landing-page">
      {/* Navbar */}
      <div className="absolute top-0 left-0 w-full flex justify-between items-center p-4 z-50">
        <img
          src="/billdrip-logo-noback.png"
          alt="Billdrip Logo"
          className="h-8 sm:h-10 md:h-12 ml-2 md:ml-4"
        />
        <div className="flex items-center gap-2 sm:gap-3 md:gap-4">
          <Button
            variant="ghost"
            className="text-[#F1F6F5] bg-[#8791F3] hover:text-[#34375B] hover:bg-[#5CC2BB] hover:shadow-[4px_4px_0px_0px_#34375B] hover:-translate-x-1 hover:-translate-y-1 transition-all duration-200 text-xs sm:text-sm md:text-base px-2 py-1 sm:px-3 sm:py-2 md:px-4 md:py-2"
            onClick={() => navigate("/login")}
          >
            {t("hero.login")}
          </Button>
          <Button
            className="text-[#34375B] bg-[#5CC2BB] hover:text-[#F1F6F5] hover:bg-[#8791F3] hover:shadow-[4px_4px_0px_0px_#34375B] hover:-translate-x-1 hover:-translate-y-1 transition-all duration-200 text-xs sm:text-sm md:text-base px-2 py-1 sm:px-3 sm:py-2 md:px-4 md:py-2"
            onClick={() => navigate("/signup")}
          >
            {t("auth.sign_up")}
          </Button>
          <LanguageSwitcher />
        </div>
      </div>

      {/* Sections - Full Width */}
      <HeroSection />
      <FeaturesSection />
      <HowItWorksSection />
      <PricingSection />

      {/* Footer */}
      <footer className="bg-white/80 backdrop-blur-sm border-t border-gray-200 py-8">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex items-center space-x-6">
              <Link
                to="/privacy-policy"
                className="text-gray-600 hover:text-gray-900 transition-colors"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms-of-service"
                className="text-gray-600 hover:text-gray-900 transition-colors"
              >
                Terms of Service
              </Link>
            </div>
            <a
              href="mailto:contact@billdrip.com"
              className="text-gray-600 hover:text-gray-900 transition-colors"
            >
              contact@billdrip.com
            </a>
            <div className="text-gray-600">
              © {new Date().getFullYear()} Billdrip. All rights reserved.
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Landing;
